import Dexie, { type Table } from 'dexie'

export interface Note {
  id: string
  content: string
  custom_title: string | null
  created_at: string
  updated_at: string
  is_deleted: boolean
  is_pinned: boolean
  synced_at: string | null
  user_id: string | null
  version: number
}

export interface ImageRecord {
  id: string            // UUID
  note_id: string       // FK to note
  data: Blob            // raw image blob
  mime_type: string     // e.g. "image/webp"
  size: number          // bytes
  created_at: string
  synced_at: string | null
  user_id: string | null  // set after image is pushed to server
}

export class YellowPadDB extends Dexie {
  notes!: Table<Note>
  images!: Table<ImageRecord>

  constructor() {
    super('yellowpad')
    this.version(1).stores({
      notes: 'id, updated_at, is_deleted, synced_at, user_id'
    })
    this.version(2).stores({
      notes: 'id, updated_at, is_deleted, synced_at, user_id',
      images: 'id, note_id, synced_at'
    })
    this.version(3).stores({
      notes: 'id, updated_at, is_deleted, is_pinned, synced_at, user_id',
    }).upgrade(trans => {
      return trans.table('notes').toCollection().modify(note => {
        note.is_pinned = false
      })
    })
    this.version(4).stores({
      notes: 'id, updated_at, is_deleted, is_pinned, synced_at, user_id',
    }).upgrade(trans => {
      return trans.table('notes').toCollection().modify(note => {
        if (note.version === undefined) note.version = 1
      })
    })
    this.version(5).stores({
      notes: 'id, updated_at, is_deleted, is_pinned, synced_at, user_id',
      images: 'id, note_id, synced_at, user_id',
    }).upgrade(trans => {
      return trans.table('images').toCollection().modify(image => {
        if (image.user_id === undefined) image.user_id = null
      })
    })
    this.version(6).stores({
      notes: 'id, updated_at, is_deleted, is_pinned, synced_at, user_id',
      images: 'id, note_id, synced_at, user_id',
    }).upgrade(trans => {
      return trans.table('notes').toCollection().modify(note => {
        if (note.custom_title === undefined) note.custom_title = null
      })
    })
  }
}

export const db = new YellowPadDB()
